import './system/core';
import './astridd';
import './components/blog';
import './components/site';
import './components/payments';
import Astridd from './system/init';

Astridd();
